var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSlippage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-slippage",
    clipPath: "url(#clip0_1041_3322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60952 0H14.6666C15.1245 0 15.5 0.360427 15.5 0.8C15.5 1.23957 15.1245 1.6 14.6666 1.6H1.60952C1.15158 1.6 0.776089 1.23957 0.776089 0.8C0.776089 0.360427 1.15158 0 1.60952 0ZM1.24585 11.4635C1.49545 11.4843 1.74069 11.402 1.91868 11.2343L3.27734 9.93014C3.81342 9.41555 4.10751 8.73014 4.10751 8.00201C4.10751 7.27387 3.81342 6.58846 3.27734 6.07387L1.91868 4.76971C1.76024 4.61763 1.54972 4.53534 1.32942 4.53534C1.30446 4.53534 1.28167 4.53534 1.25671 4.53846C1.00711 4.55929 0.790071 4.68013 0.642498 4.88222C0.414608 5.19161 0.475379 5.64993 0.784659 5.94369L2.1379 7.24265C2.34951 7.44577 2.46563 7.71763 2.46563 8.00307C2.46563 8.28849 2.34843 8.56036 2.1379 8.7635L0.762962 10.0833C0.47104 10.3635 0.4157 10.7927 0.629483 11.102C0.773814 11.3125 0.993025 11.4406 1.24589 11.4645L1.24585 11.4635ZM14.6666 14.4H1.60952C1.15158 14.4 0.776089 14.7604 0.776089 15.2C0.776089 15.6396 1.15158 16 1.60952 16H14.6666C15.1245 16 15.5 15.6396 15.5 15.2C15.5 14.7604 15.1245 14.4 14.6666 14.4ZM14.6666 4.8H7.72133C7.26339 4.8 6.8879 5.16043 6.8879 5.6C6.8879 6.03958 7.26339 6.4 7.72133 6.4H14.6666C15.1245 6.4 15.5 6.03958 15.5 5.6C15.5 5.16043 15.1245 4.8 14.6666 4.8ZM7.72133 9.6H14.6666C15.1245 9.6 15.5 9.96043 15.5 10.4C15.5 10.8396 15.1245 11.2 14.6666 11.2H7.72133C7.26339 11.2 6.8879 10.8396 6.8879 10.4C6.8879 9.96043 7.26339 9.6 7.72133 9.6Z",
    fill: "#A0A3A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_3322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSlippage);
export default __webpack_public_path__ + "static/media/icn_slippage.1c30a446da4b5591c147431ed7acdba5.svg";
export { ForwardRef as ReactComponent };